module.exports = __webpack_public_path__ + "img/google_logo.10588e25.png";